import React, { useState } from "react";
import PopupDetail from "../popup-details/popupDetail";

const BubbleChat = ({ messages, isLoading, userName }) => {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [urlMessage, setUrlMessage] = useState("");

  const handleViewDetailsClick = (msg) => {
    const extractedUrl = msg.text.match(/\[(.*?)\]/)
      ? msg.text.match(/\[(.*?)\]/)[1]
      : "";
    setUrlMessage(extractedUrl);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    setUrlMessage("");
  };

  return (
    <div className="bubble-chat">
      {isLoading && (
        <div className="bubble-chat__ai--message">
          <div className="bubble-chat__ai--waiting">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {messages
        .slice(0)
        .reverse()
        .map((msg, index) => {
          const messageUrl =
            msg.text && msg.text.match(/\[(.*?)\]/)
              ? msg.text.match(/\[(.*?)\]/)[1]
              : null;

          return (
            <React.Fragment key={index}>
              {msg.type === "system" ? (
                <div className="bubble-chat__system--message">
                  {msg.text}
                </div>
              ) : (
                <>
                  {msg.type === "ai" && messageUrl && (
                    <div className="bubble-chat__view-details">
                      <button onClick={() => handleViewDetailsClick(msg)}>
                        View details
                      </button>
                    </div>
                  )}

                  <div className={`bubble-chat__${msg.type}--message`}>
                    {msg.type === "user" && (
                      <p className="bubble-chat__username">{userName}</p>
                    )}
                    {msg.text.replace(/\[.*?\]/, "")}
                  </div>
                </>
              )}
            </React.Fragment>
          );
        })}

      {isPopupVisible && urlMessage && (
        <PopupDetail urlMessage={urlMessage} closePopup={closePopup} />
      )}
    </div>
  );
};

export default BubbleChat;
